export default () => {

    // Header Mobile Menu

    $('.nav .sub-menu').append(
        '<li class="back-sub-menu"><a href="javascript:void(0);">zurück</a></li>'
    );

    $('.nav .back-sub-menu').click(function() {
        $(this).closest('.open-sub-menu').removeClass('open-sub-menu');
    });

    function openSubMenuMobile() {
        var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (winWidth < 1200) {
            $('.nav .menu-item-has-children > a').click(function(e) {
                e.preventDefault();
                $(this).parent().addClass('open-sub-menu');
            });
        }
    }

    openSubMenuMobile();

    $(window).on('resize', function() {
        openSubMenuMobile();
    });

    $('.header-btn').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('open-nav');
    });

    $('.section-hero-bg').closest('body').addClass('header-no-bg');

    // Learndash Header Mobile Menu

    $('.ld-trigger-mobile-nav').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('ld-open-nav');
    });

    $('.ld-focus-sidebar-trigger').click(function() {
        $('body').removeClass('ld-open-nav');
    });

    // Header Contact

    $('.link-contact-open').click(function(e) {
        e.preventDefault();
        $('body').addClass('contact-open');
    });

    $('.link-contact-close, .btn-contact-close').click(function(e) {
        e.preventDefault();
        $('body').removeClass('contact-open');
    });

    // Header Sticky

    $(window).scroll(function () {
        if ($(window).scrollTop() > 1) {
            $('.header').addClass('fixed');
        } else {
            $('.header').removeClass('fixed');
        }
    });

    // Share Buttons

    $('.js-share-button').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('open-share-buttons');
    });

    // Height 100vh

    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    }
    window.addEventListener('resize', appHeight);
    appHeight();

    // Cards Slider

    $('.cards-slider .grid').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Accordion

    $('.ld-item-list-group').hide();
    $('.ld-item-list-section-heading:first-child').addClass('active');
    $('.ld-item-list-section-heading.active + .ld-item-list-group').show();

    $('.ld-item-list-section-heading').click(function() {
        $(this).next().slideToggle(300);
        //$('.ld-item-list-group').not($(this).next()).slideUp(300);
        $(this).toggleClass('active');
        //$('.ld-item-list-section-heading').not($(this)).removeClass('active');
    });

    $('.ld-lesson-items-group').hide();
    $('.ld-lesson-item-section-heading.active + .ld-lesson-items-group').show();

    $('.ld-lesson-item-section-heading').click(function() {
        $(this).next().slideToggle(300);
        $(this).toggleClass('active');
    });

    $('.accordion-content').hide();
    $('.accordion-heading.active + .accordion-content').show();

    $('.accordion-heading').click(function() {
        $(this).next().slideToggle(300);
        $('.accordion-content').not($(this).next()).slideUp(300);
        $(this).toggleClass('active');
        $('.accordion-heading').not($(this)).removeClass('active');
    });

    // Custom Filter Select

    $('select').amsifySelect({
        hideButtons: true,
    });

    $('.block-filter-text.active').closest('.block-search-filter').find('.block-filter-wrap').hide();
    $('.block-filter-text').click(function() {
        $(this).closest('.block-search-filter').find('.block-filter-wrap').slideToggle(300);
        $(this).toggleClass('active');
    });

    // Event Filter Bar

    $(document).on('click', '.js-event-tag-filter', function(e){
        e.preventDefault();
        let $this = $(this);
        $this.addClass('active').siblings('.js-event-tag-filter').removeClass('active');
        $this.parents('.tribe-events').find('[name="tribe_tags[]"]').val(tag_id).change();
    });

    // Lexicon Filter Bar

    $('.js-filter-lexicon').click(function(e){
        e.preventDefault();
        let $this = $(this);
        $this.addClass('active').siblings('.js-filter-lexicon').removeClass('active');
    });

    // Login/Registration

    $('.js-learndash-login').click(function(e) {
        e.preventDefault();
        if ( $('.ld-login-button').hasClass('ld-login') ) {
            $('.ld-login-button').trigger('click');
            $('body').removeClass('open-nav');
            //$('html, body').stop();
        }
        if ( $('.ld-login-button').hasClass('ld-logout') ) {
            window.location.href = $('.ld-login-button').attr('href');
        }
    });

    $('.learndash-registration-field-password [name="password"]').change(function(){
        $('.learndash-registration-field-confirmpassword [name="confirm_password"]').val($('.learndash-registration-field-password [name="password"]').val());
    });

    if ( $('body').hasClass('single-sfwd-courses') ) {
        if ( !$('.section-cards-slider .item').length ) {
            $('.section-cards-slider').hide();
        }
    }

    // Iframe Wrapper

    $('.wpProQuiz_content iframe').wrap('<div class="iframe-wrap"></div>');

    // Popup

    $('[data-fancybox]').fancybox();

    // Filter search form

    $(document).on('click', '.list-tags .box-item', function(){
        $(this).parents('form').find('.amsify-list-item:contains('+$(this).text()+')').click();
        showHideClearBtn($(this).parents('.block-filter-btn'));
        $(this).remove();
    });

    $('.block-search-form form').each(function(){
        showHideClearBtn($(this));
    });

    $('.block-search-form input, .block-search-form select').change(function(){
        showHideClearBtn($(this));
    });

    $('.block-search-form .box-filter, .block-search-form .btn-clear-filter').click(function(){
        showHideClearBtn($(this));
    });

    //Form edit user profile

    $('.form-user-profile [name="birthday"]').mask('00.00.0000');

    $('.form-user-profile [name="photo"]').change(function(e) {
        var parentField = $(this).parents('.file-upload-wrap');
        parentField.find('.box-validation').remove();
        var fileSizeMax = Math.floor($(this).data('size-max'));
        var fileSizeError = $(this).data('size-error');
        var $file = e.target.files[0];
        if ( $file.size > fileSizeMax ) {
            parentField.append('<div class="box-validation">'+fileSizeError+'</div>');
        }
        else {
            var newImageUrl = URL.createObjectURL($file);
            parentField.find('img').attr('src', newImageUrl);
        }
    });

    /*$('.form-user-profile [name="consent"]').change(function(e) {
        var $form = $(this).parents('form');
        if ( $(this).is(':checked') ) {
            $form.find('[type="submit"]').removeAttr('disabled');
        }
        else {
            $form.find('[type="submit"]').attr('disabled', 'disabled');
        }
    });*/


    function showHideClearBtn(el) {
        setTimeout(function(){
            let elParent = el.parents('.block-search-form');
            let showClearBtn = false;
            if ( elParent.find('[name="search"]').val() ) {
                showClearBtn = true;
            }
            if ( elParent.find('.box-filter.active').not('[data-type="all"]').length ) {
                showClearBtn = true;
            }
            if ( elParent.find('.list-tags .box-item').length ) {
                showClearBtn = true;
            }
            if (showClearBtn) {
                elParent.find('.btn-clear-filter').show();
            }
            else {
                elParent.find('.btn-clear-filter').hide();
            }
        }, 40);
    }

}
